<template>
  <div>
    <!-- 文本: 优惠券 -->
    <el-dialog :title="$t('message.coupons')" :close-on-click-modal="false" :visible.sync="show" width="30%"
      @close="handleClose()" center>
      <div class="couponsList">
        <p v-for="(item, index) in $parent.usableDiscountList" @click="setctive(item, index)" :key="index"
          :class="{ active: active == index }">
          <span>{{ item.name_chinese }}</span>
          <span>券编号:{{ item.sn }}</span>
          <!-- <span v-if="item.type == 2">
            优惠金额 (日元) :{{ item.discounts_amount_jpy }}
          </span>
          <span v-else>可用次数{{ item.discounts_amount_jpy }}次</span> -->
          <template v-if="item.type != 3">
            <span>
              <span>{{
      item.type_name == "代金券" ? "优惠金额 (日元)" : "可用次数"
    }}</span>
              <span>
                {{
        item.type_name == "优惠券"
          ? "免手续费"
          : item.type_name == "代金券"
            ? item.discounts_amount_jpy
            : ""
      }}</span>
              <span>{{ item.type_name == "代金券" ? "円" : "次" }}</span>
            </span>
          </template>
          <template v-else>
            <span>
              {{
      item.discounts_amount_jpy && item.discounts_amount_jpy != "0"
        ? "优惠金额 (日元)"
        : "折扣比例"
    }}:
              {{
        item.discounts_amount_jpy && item.discounts_amount_jpy != "0"
          ? item.discounts_amount_jpy
          : Math.round(item.discounts_rate)
      }}
              {{
        item.discounts_amount_jpy && item.discounts_amount_jpy != "0"
          ? "円"
          : "%"
      }}
            </span>
          </template>
          <span>生效日期 :{{ item.effective_date }}</span>
          <span>失效日期 :{{ item.expiry_date }}</span>
          <!-- 使用限制 -->
          <template v-if="item.type == 3">
            <span class="conditionsItem">
              <span>{{ "使用条件" }}：</span>

              <span>{{ item.logistics_group[0].logistics_name || "所有物流" }}；</span>
            </span>
            <span class="conditionsItem">
              <span>{{ "计费重量" }}：</span>
              <span>{{ item.min_weight }}KG；</span>
            </span>
            <span class="conditionsItem">
              <span>{{ "最低使用金额" }}：</span>
              <span>{{ item.min_consumption_jpy }}円；</span>
            </span>
          </template>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="
      active = -1;
    show = false;
    ">{{ $t("message.cancel") }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="show = false">{{
      $t("message.ok")
    }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      active: -1,
      oldactive: -1,
      odata: {
        successMethods: () => { },
      },
      usercoupons: [], // 使用的券的数据列表,为了可以使用多种券做成列表形式
    };
  },
  components: {},
  computed: {
    // 是否已使用优惠券
    isUsed() {
      return !(this.active == -1);
    },
  },
  created() { },
  methods: {
    handleClose() {
      this.$parent.isUsed = this.isUsed;
      // 统计优惠券使用金额
      if (this.active > -1) {
        this.$parent.preferentialAmount.name =
          this.$parent.usableDiscountList[this.active].name_chinese;
      } else {
        this.$parent.preferentialAmount.name = "";
      }
      this.odata.successMethods(this.active);
    },
    // 选择优惠券
    setctive(item, index) {
      if (this.active == index) {
        this.active = -1;
        this.usercoupons = [];
      } else {
        this.active = index;
        this.usercoupons = [this.$parent.usableDiscountList[this.active]];
      }
    },
    // 打开弹窗
    open(data) {
      this.oldactive = this.active;
      // 赋值弹窗参数
      for (let i in data) {
        this.odata[i] = data[i];
      }
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.couponsList {
  max-height: 500px;
  overflow: auto;

  p {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 10px 0;
    margin: 10px 0;
    background-color: #f8f8f8;
    cursor: pointer;

    span {
      margin: 5px 0;
    }
  }

  p.active {
    background-color: antiquewhite;
  }
}
</style>
